import { render } from "./App.vue?vue&type=template&id=64ea5919"
const script = {}

import "./App.vue?vue&type=style&index=0&id=64ea5919&lang=css"

import exportComponent from "D:\\Wyspace\\WechatPlatForm_XINXIN\\WechatPlatForm\\Vue.EmployApply\\employVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__